import React from 'react'
import SideBar from '../../components/UserDashboard/SideBar'
import EfficiencyHeader from '../../components/Efficiency/EfficiencyHeader'
import reportLogo from "../../images/reportLogo.png"
import { Link } from 'react-router-dom';
function EfficiencyReport() {
  
// const reportData = [
//   { title: "Report 001", date: "02-05-2025",id:"1" },
//   { title: "Report 002", date: "02-05-2026",id:"2" },
//   { title: "Report 003", date: "02-05-2027",id:"3" },
// ];
  return (
    <>
    <div className='flex'>
<div>
    <SideBar/>

</div>
<div>

    <div> 
<Link  className='ml-10 mt-32 flex' to={"/efficiency-home"} >

      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.0004 10.9987H7.83041L12.7104 6.11869C13.1004 5.72869 13.1004 5.08869 12.7104 4.69869C12.6179 4.60599 12.508 4.53244 12.387 4.48226C12.2661 4.43208 12.1364 4.40625 12.0054 4.40625C11.8744 4.40625 11.7448 4.43208 11.6238 4.48226C11.5028 4.53244 11.3929 4.60599 11.3004 4.69869L4.71041 11.2887C4.61771 11.3812 4.54416 11.4911 4.49398 11.6121C4.4438 11.733 4.41797 11.8627 4.41797 11.9937C4.41797 12.1247 4.4438 12.2543 4.49398 12.3753C4.54416 12.4963 4.61771 12.6062 4.71041 12.6987L11.3004 19.2887C11.393 19.3813 11.5029 19.4547 11.6239 19.5048C11.7448 19.5549 11.8745 19.5807 12.0054 19.5807C12.1363 19.5807 12.266 19.5549 12.387 19.5048C12.5079 19.4547 12.6178 19.3813 12.7104 19.2887C12.803 19.1961 12.8764 19.0862 12.9265 18.9652C12.9766 18.8443 13.0024 18.7146 13.0024 18.5837C13.0024 18.4528 12.9766 18.3231 12.9265 18.2022C12.8764 18.0812 12.803 17.9713 12.7104 17.8787L7.83041 12.9987H19.0004C19.5504 12.9987 20.0004 12.5487 20.0004 11.9987C20.0004 11.4487 19.5504 10.9987 19.0004 10.9987Z" fill="black"/>
</svg>
<div className='text-2xl'>Back </div>
</Link>

<div className='ml-[1000px] '>
<EfficiencyHeader/>
</div>
</div>

<div className='ml-[20px] text-[24px]'>Energy Efficiency Monitoring and Emissions Reduction Report </div>
 <div className="space-y-10 gap-10 mt-20 mr-20 w-[1112px] ml-20 mb-5">
      {/* Header details row */}
      <div className="flex flex-row items-center gap-[42px] w-full">
        <div className="flex flex-col gap-4 w-[281px]">
          <div className="text-[16px] leading-[19px] text-[#101828]">Organization Name:</div>
          <div className="text-[18px] leading-[27px] font-medium text-[#101828]">Insert Facility or Company Name</div>
        </div>
        <div className="flex flex-col gap-4 w-[281px]">
          <div className="text-[16px] leading-[19px] text-[#101828]">Reporting Period:</div>
          <div className="text-[18px] leading-[27px] font-medium text-[#101828]">E.g. Jan 2025 – June 2025</div>
        </div>
        <div className="flex flex-col gap-4 w-[144px]">
          <div className="text-[16px] leading-[19px] text-[#101828]">Date Issued:</div>
          <div className="text-[18px] leading-[27px] font-medium text-[#101828]">Insert Date</div>
        </div>
        <div className="flex flex-col gap-4 w-[280px]">
          <div className="text-[16px] leading-[19px] text-[#101828]">Prepared by:</div>
          <div className="text-[18px] leading-[27px] font-medium text-[#101828]">Netzence Sustainability Limited</div>
        </div>
      </div>

      {/* Executive Summary */}
      <div className="flex flex-col gap-4 w-full">
        <div className="text-[22px] leading-[33px] font-medium text-[#101828]">Executive Summary</div>
        <div className="flex flex-col gap-6 w-full">
          <div className="flex flex-col gap-3 w-full">
            <div className="text-[18px] leading-[22px] text-[#101828]">Objective:</div>
            <div className="text-[18px] leading-[27px] font-medium text-[#667185]">
              To quantify the energy savings and corresponding Greenhouse Gas (GHG) emissions reduction achieved from Energy Efficiency (EE)
              interventions using the IPMVP Option C (Whole Facility) methodology.
            </div>
          </div>
          <div className="flex flex-col gap-3 w-full">
            <div className="text-[18px] leading-[22px] text-[#101828]">Key Findings:</div>
            <div className="flex flex-col gap-4 w-full">
              <div className="text-[18px] leading-[27px] font-medium text-[#667185]">Total Energy Saved:<span className='text-black'>[X,XXX kWh] </span> </div>
              <div className="text-[18px] leading-[27px] font-medium text-[#667185]">Emission Reduction Achieved:  <span className='text-black'>[XXX.XX tCO₂e]</span></div>
              <div className="text-[18px] leading-[27px] font-medium text-[#667185]">Reduction Compared to Baseline:  <span className='text-black'>[X.X%]</span></div>
            </div>
          </div>
          <div className="flex flex-col gap-3 w-full">
            <div className="text-[18px] leading-[22px] text-[#101828]">Notable Trends:</div>
            <div className="text-[18px] leading-[27px] font-medium text-[#101828]">
            <span className='text-gray-600'>Summarize insights</span>  E.g. “Significant reduction in generator use during peak hours due to operational shift to solar.”
            </div>
          </div>
        </div>
      </div>

      {/* Monitoring Framework */}
      <div className="flex flex-col gap-4 w-full">
        <div className="text-[22px] leading-[33px] font-medium text-[#101828]">Monitoring Framework</div>
        <div className="flex flex-col gap-6 w-full">
          <div className="flex flex-col gap-3 w-full">
            <div className="text-[18px] leading-[22px] text-[#101828]">Scope of Report:</div>
            <div className="text-[18px] leading-[27px] font-medium text-[#667185]">
              It covers the total energy consumption of the facility, including inputs from grid electricity, diesel generators, and solar systems,
              both before and after EE measures were implemented.
            </div>
          </div>

          <div className="flex flex-col gap-3 w-full">
            <div className="text-[18px] leading-[22px] text-[#101828]">Data Collection Process:</div>
            <div className="flex flex-col gap-4 w-full">
              <div className="text-[18px] leading-[27px] font-medium text-[#667185]">IoT-enabled meters installed across the facility to monitor grid, generator, and solar inputs.</div>
              <div className="text-[18px] leading-[27px] font-medium text-[#667185]">Baseline period: <span className='text-black'>[Insert months]</span></div>
              <div className="text-[18px] leading-[27px] font-medium text-[#667185]">Monitoring period:<span className='text-black'>[Insert months]</span></div>
              <div className="text-[18px] leading-[27px] font-medium text-[#667185]">Data Collection method: <span className='text-black'> IoT Device </span></div>
            </div>
          </div>

          <div className="flex flex-col gap-3 w-full">
            <div className="text-[18px] leading-[22px] text-[#101828]">Emission Factors Applied:</div>
            <div className="text-[18px] leading-[27px] font-medium text-[#667185]">Sourced from IPCC Guidelines (2006), and local adaptation factors where applicable.</div>
          </div>

          <div className="flex flex-col gap-3 w-full">
            <div className="text-[18px] leading-[22px] text-[#101828]">Standards Applied:</div>
            <div className="flex flex-col gap-4 w-full">
              <div className="text-[18px] leading-[27px] font-medium text-[#667185]">IPMVP Core Concepts (2016) – Option C</div>
              <div className="text-[18px] leading-[27px] font-medium text-[#667185]">ISO 50006</div>
            </div>
          </div>
        </div>
      </div>

      {/* Energy Consumption Summary */}
      <div className="flex flex-col gap-4 w-full">
        <div className="text-[22px] leading-[33px] font-medium text-[#101828]">Energy Consumption Summary</div>
        <div className="flex flex-row items-center gap-6 w-full">
          {/* Baseline */}
          <div className="flex flex-col gap-4 w-[544px]">
            <div className="text-[18px] leading-[22px] text-[#101828]">Baseline Period Consumption (Before EE Implementation)</div>
            <div className="border border-[#E5E5E5] rounded-lg">
              <div className="relative">
                <div className="absolute left-6 top-6 text-[16px] text-[#667185]">Baseline Monitoring Period:</div>
              </div>
              <div className="flex w-full">
                <div className="w-[166px] h-[55px] bg-[#2C9963] border-b border-[rgba(177,177,177,0.4)] flex items-center justify-center px-6">
                  <div className="text-white text-[14px] font-medium">Source</div>
                </div>
                <div className="w-[186px] h-[55px] bg-[#2C9963] border-b border-[rgba(177,177,177,0.4)] flex items-center justify-center px-6">
                  <div className="text-white text-[14px] font-medium">Consumption (kWh)</div>
                </div>
                <div className="w-[192px] h-[55px] bg-[#2C9963] border-b border-[rgba(177,177,177,0.4)] flex items-center justify-center px-6">
                  <div className="text-white text-[14px] font-medium">Share (%)</div>
                </div>
              </div>
              <div className="flex flex-col w-full">
                {[
                  { label: 'Grid', val1: '-', val2: '-' },
                  { label: 'Generator', val1: '-', val2: '-' },
                  { label: 'Solar', val1: '-', val2: '-' },
                  { label: 'Total', val1: '-', val2: '-', total: true },
                ].map((row, idx) => (
                  <div key={idx} className="flex w-full">
                    <div className={`w-[166px] h-[72px] border-b border-[#EFEFEF] flex items-center justify-center px-6 ${row.total ? 'text-[#667185] font-semibold' : 'text-[#667185]'}`}>
                      <div className={`${row.total ? 'text-[14px] font-semibold' : 'text-[14px]'}`}>{row.label}</div>
                    </div>
                    <div className={`w-[186px] h-[72px] border-b border-[#EFEFEF] flex items-center justify-center px-6 ${row.total ? 'font-semibold text-[#101828]' : 'text-[#101828]'}`}>
                      <div className="text-[14px]">{row.val1}</div>
                    </div>
                    <div className={`w-[192px] h-[72px] border-b border-[#EFEFEF] flex items-center justify-center px-6 ${row.total ? 'font-semibold text-[#101828]' : 'text-[#101828]'}`}>
                      <div className="text-[14px]">{row.val2}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Monitoring */}
          <div className="flex flex-col gap-4 w-[544px]">
            <div className="text-[18px] leading-[22px] text-[#101828]">Monitoring Period Consumption (After EE Implementation)</div>
            <div className="border border-[#E5E5E5] rounded-lg">
              <div className="relative">
                <div className="absolute left-6 top-6 text-[16px] text-[#667185]">Monitoring Period:</div>
              </div>
              <div className="flex w-full">
                <div className="w-[166px] h-[55px] bg-[#2C9963] border-b border-[rgba(177,177,177,0.4)] flex items-center justify-center px-6">
                  <div className="text-white text-[14px] font-medium">Source</div>
                </div>
                <div className="w-[186px] h-[55px] bg-[#2C9963] border-b border-[rgba(177,177,177,0.4)] flex items-center justify-center px-6">
                  <div className="text-white text-[14px] font-medium">Consumption (kWh)</div>
                </div>
                <div className="w-[192px] h-[55px] bg-[#2C9963] border-b border-[rgba(177,177,177,0.4)] flex items-center justify-center px-6">
                  <div className="text-white text-[14px] font-medium">Share (%)</div>
                </div>
              </div>
              <div className="flex flex-col w-full">
                {[
                  { label: 'Grid', val1: '-', val2: '-' },
                  { label: 'Generator', val1: '-', val2: '-' },
                  { label: 'Solar', val1: '-', val2: '-' },
                  { label: 'Total', val1: '-', val2: '-', total: true },
                ].map((row, idx) => (
                  <div key={idx} className="flex w-full">
                    <div className={`w-[166px] h-[72px] border-b border-[#EFEFEF] flex items-center justify-center px-6 ${row.total ? 'text-[#667185] font-semibold' : 'text-[#667185]'}`}>
                      <div className={`${row.total ? 'text-[14px] font-semibold' : 'text-[14px]'}`}>{row.label}</div>
                    </div>
                    <div className={`w-[186px] h-[72px] border-b border-[#EFEFEF] flex items-center justify-center px-6 ${row.total ? 'font-semibold text-[#101828]' : 'text-[#101828]'}`}>
                      <div className="text-[14px]">{row.val1}</div>
                    </div>
                    <div className={`w-[192px] h-[72px] border-b border-[#EFEFEF] flex items-center justify-center px-6 ${row.total ? 'font-semibold text-[#101828]' : 'text-[#101828]'}`}>
                      <div className="text-[14px]">{row.val2}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Emissions & Energy Reduction Summary */}
      <div className="flex flex-col gap-4 w-full">
        <div className="text-[22px] leading-[33px] font-medium text-[#101828]">Emissions & Energy Reduction Summary</div>
        <div className="border border-[#E5E5E5] rounded-lg">
          <div className="flex w-full">
            <div className="w-[555px] h-[55px] bg-[#2C9963] border-b border-[rgba(177,177,177,0.4)] flex items-center justify-center px-6">
              <div className="text-white text-[14px] font-medium">Metric</div>
            </div>
            <div className="w-[556px] h-[55px] bg-[#2C9963] border-b border-[rgba(177,177,177,0.4)] flex items-center justify-center px-6">
              <div className="text-white text-[14px] font-medium">Value</div>
            </div>
          </div>
          {[
            { metric: 'Total Energy Saved (kWh)', value: '-' },
            { metric: 'Emission Reduction (tCO₂e)', value: '-' },
            { metric: 'Reduction vs Baseline (%)', value: '-' },
            { metric: 'Emission Intensity Change (kg CO₂e/kWh)', value: '-' },
          ].map((row, idx) => (
            <div key={idx} className="flex w-full">
              <div className="w-[555px] h-[72px] border-b border-[#EFEFEF] flex items-center px-6">
                <div className="text-[14px] text-[#667185]">{row.metric}</div>
              </div>
              <div className="w-[556px] h-[72px] border-b border-[#EFEFEF] flex items-center px-6">
                <div className="text-[14px] text-[#101828]">{row.value}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Trend Analysis */}
      <div className="flex flex-col gap-4 w-full">
        <div className="text-[22px] leading-[33px] font-medium text-[#101828]">Trend Analysis</div>
        <div className="flex flex-col gap-6 w-full">
          <div className="flex flex-col gap-4 w-full">
            <div className="text-[18px] leading-[27px] font-medium text-[#667185]">
              During the reporting period, the facility recorded a <span className='text-black'> [increase/decrease/stable pattern] </span> in total energy consumption compared to the
              baseline period. This change was primarily influenced by variations in energy use across the available sources (e.g., grid, generator,
              and solar).
            </div>
            <div className="text-[18px] leading-[27px] font-medium text-[#667185]">Grid energy usage <span className='text-black'>[increased/decreased/remained stable] </span>  by <span className='text-black'> [X]%.</span></div>
            <div className="text-[18px] leading-[27px] font-medium text-[#667185]">Diesel generator usage <span className='text-black'> [increased/decreased] </span> by <span className='text-black'> [X]%.</span></div>
            <div className="text-[18px] leading-[27px] font-medium text-[#667185]">Solar energy contribution <span className='text-black'> [increased/decreased/stabilized],</span> accounting for <span className='text-black'> [X]% </span>of total energy during the monitoring period.</div>
            <div className="text-[18px] leading-[27px] font-medium text-[#667185]">As a result, the facility’s emission intensity changed from <span className='text-black'>[X.XXX] </span> to <span className='text-black'> [X.XXX] </span> kg CO₂e/kWh, representing a <span className='text-black'>[X]% </span>improvement/degradation in carbon efficiency.</div>
          </div>
          <div className="text-[18px] leading-[27px] font-medium text-[#101828]">
            The observed trends confirm that the implemented energy efficiency measures have <span className='text-black'> [positively/negatively] </span>impacted the facility's energy and emissions profile.
          </div>
        </div>
      </div>

      {/* Emissions Calculation Summary */}
      <div className="flex flex-col gap-4 w-full">
        <div className="text-[22px] leading-[33px] font-medium text-[#101828]">Emissions Calculation Summary</div>
        <div className="flex flex-col gap-3 w-full">
          <div className="text-[18px] leading-[22px] text-[#101828]">Full formulas and derivations based on:</div>
          <div className="flex flex-col gap-4 w-full">
<ul className="list-disc space-y-5 pl-6 mb-5">
  <li className="text-[18px] leading-[27px] font-medium text-[#667185]">IPMVP Option C</li>
  <li className="text-[18px] leading-[27px] font-medium text-[#667185]">IPCC Emission Factors</li>
  <li className="text-[18px] leading-[27px] font-medium text-[#667185]">ISO 50006 performance metrics</li>
</ul>
          </div>
        </div>
      </div>
    </div>

</div>

    

    </div>


    </>

  )
}

export default EfficiencyReport
